export default {
  'dialog.cancel': 'Annuleer',
  'dialog.close': 'Sluit',

  // Confirmation dialog
  'confirmation-dialog.title': 'Weet je het zeker?',
  'confirmation-dialog.confirm': 'Bevestig',
};
